export default "__VITE_ASSET__94AULmQ4__"